module.exports = __webpack_public_path__ + "static/media/freight-system-img.3f0fb014.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/productService/images/freight-system-img.png
// module id = 152
// module chunks = 0